import { createApp } from 'vue';
import SearchYandex from './vue-components/pages/search-yandex/SearchYandex';

document.addEventListener('DOMContentLoaded', () => {
    const parent = document.getElementById('search-yandex-page');

    if (parent) {
        createApp({
            components: { SearchYandex },
            data() {
                return {
                    isEmptySearchField: false
                };
            },
            mounted() {
                const params = new URLSearchParams(window.location.search);
                this.isEmptySearchField = !(params.has('searchid') || params.has('text'));
            }
        }).mount(parent);
    }
});
